import Handsontable from 'handsontable/base';
import { CellSelections } from '../../../../../../common/table/TableTypes';
import { isEqual } from 'lodash';
import {
    getEndCol,
    getEndRow,
    getStartCol,
    getStartRow,
    isSelectingRefColHeader,
    isSelectingRefRowHeader,
} from '../tableCellSelectionUtils';
import { asObject } from '../../../../../../common/utils/immutableHelper';
import { setTransactionIdForNextUpdateCellSelection } from './_hotTableSelectionTransactionIdUtils';

/**
 * Moves the cell selections in the Handsontable instance to match the provided cellSelections.
 */
export const updateHotTableCellSelections = (
    hotInstance: Handsontable.Core | null | undefined,
    cellSelections: CellSelections,
    // TODO-TABLES-MOBILE - Determine if this really needs to be provided (see comment on addHotTableColsRight)
    transactionId?: number,
) => {
    if (!hotInstance) return;

    hotInstance.deselectCell();

    if (!cellSelections) return;

    // TODO-TABLES - Not sure why this asObject conversion is needed, but keeping it for now to avoid breaking changes
    const newCellSelections = asObject(cellSelections) as CellSelections;

    const currentHotCellSelections = hotInstance.getSelected();
    if (isEqual(newCellSelections, currentHotCellSelections)) return;

    // FIXME-TABLE-SELECTION - Add
    setTransactionIdForNextUpdateCellSelection(hotInstance, transactionId);

    // Prioritise on selecting the first ref column/row header if it exists in cellSelections.
    // - This is because we can't select ref headers using hot.selectCells() function. So we are not able to
    //   select ref headers and normal cells at the same time. Therefore, need to prioritise selecting one.

    const selectingRefColHeader = newCellSelections.find(isSelectingRefColHeader);
    if (selectingRefColHeader) {
        hotInstance.selectColumns(
            Math.max(getStartCol(selectingRefColHeader), 0),
            Math.min(getEndCol(selectingRefColHeader), hotInstance.countCols() - 1),
        );
        return;
    }

    const selectingRefRowHeader = newCellSelections.find(isSelectingRefRowHeader);
    if (selectingRefRowHeader) {
        hotInstance.selectRows(
            Math.max(getStartRow(selectingRefRowHeader), 0),
            Math.min(getEndRow(selectingRefRowHeader), hotInstance.countRows() - 1),
        );
        return;
    }

    hotInstance.selectCells(newCellSelections);
};
